"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoLicense = void 0;
const utils_1 = require("../utils");
exports.InfoLicense = () => {
    return {
        Info(info, { report }) {
            if (!info.license) {
                report({
                    message: utils_1.missingRequiredField('Info', 'license'),
                });
            }
        },
    };
};
